<template>
  <router-link
    v-if="v && !h"
    :tag="$props.tag"
    :to="r"
    exact-path
    class="secondary-item"
  >
    <FontAwesomeIcon
      v-if="$_.isArray(i)"
      :icon="i"
      fixed-width
    />

    <slot :text="t">
      {{ t | truncate(25) }}
    </slot>
  </router-link>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      required: false,
      default: 'li'
    },
    item: {
      type: Object,
      required: false,
      default: undefined
    },
    icon: {
      type: Array,
      required: false,
      default: undefined
    },
    text: {
      required: false,
      default: undefined,
      validator: function (value) {
        return (value && typeof value.then === 'function' && typeof value.catch === 'function')
      }
    },
    visible: {
      type: Boolean,
      required: false,
      default: true
    },
    hidden: {
      type: Boolean,
      required: false,
      default: false
    },
    route: {
      type: Object,
      required: false,
      default: undefined
    }
  },
  computed: {
    i () {
      return (this.$props.icon || this.$props.item.icon)
    },
    t () {
      return (this.$props.text || this.$props.item.name)
    },
    r () {
      return (this.$props.route || this.$props.item.route)
    },
    v () {
      return (this.$props.visible || this.$props.item.visible)
    },
    h () {
      return (this.$props.hidden || this.$props.item.hidden)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'variables';

  .secondary-item {
    font-size: .95rem;
    height: $sidebar-item-height;
    line-height: $sidebar-item-height;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      background-color: #f5f7fa;
    }

    &.router-link-active {
      color: $brand;
    }

    > svg {
      font-size: 1rem;
      padding: 0 16px;
    }
  }
</style>
